<template>
  <el-dialog append-to-body :title="title" :visible.sync="dialogVisible" width="780px" @closed="onModalClose">
    <el-form class="ghost-button-styles" label-width="120px" :model="addForm" :rules="rules">
      <el-form-item label="平台">
        <el-radio-group v-model="addForm.platform" @change="onPlatformChange">
          <el-radio-button v-for="platform in PLATFORM_LIST" :key="platform.value" ghost :label="platform.value">
            {{ platform.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="选择游戏" prop="gameId">
        <ThrottleSelector
          :popper-append-to-body="false"
          v-model="addForm.gameId"
          :list="gamesFilteredByPlatform"
          style="width: 240px"
          placeholder="全部"
          filterable
          clearable
        />
      </el-form-item>

      <el-form-item label="路径/下载地址" prop="gameAddress">
        <el-input v-model="addForm.gameAddress"></el-input>
      </el-form-item>

      <el-form-item label="渠道分成" v-if="addForm.platform === PLATFORM.MINIPROGRAM">
        <el-switch v-model="addForm.channelAdjustStatus" :active-value="1" :inactive-value="0"></el-switch>
        <div v-if="addForm.channelAdjustStatus === 1" class="share-inputs">
          <el-form-item label="IOS分成比例" prop="iosMoneyAdjust" :rules="shareRules">
            <el-input-number v-model="addForm.iosMoneyAdjust" :min="0" :max="100" :precision="2"></el-input-number>
            <span class="unit">%</span>
          </el-form-item>
          <el-form-item label="安卓分成比例" prop="androidMoneyAdjust" :rules="shareRules">
            <el-input-number v-model="addForm.androidMoneyAdjust" :min="0" :max="100" :precision="2"></el-input-number>
            <span class="unit">%</span>
          </el-form-item>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <slot></slot>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { adGames } from '@/api/common.model'
import { PLATFORM, PLATFORM_LIST } from '../../consts/index.js'
import ThrottleSelector from '@/components/throttle-select/index.vue'

const gameList = ref([])
adGames({ type: 2 }).then((data) => {
  gameList.value = data
})

const gamesFilteredByPlatform = computed(() => {
  return gameList.value.filter((item) => item.ch_platform_id === addForm.value.platform)
})

const getFormFields = () => {
  return {
    platform: PLATFORM.ANDROID,
    gameId: '',
    gameAddress: '',
    channelAdjustStatus: 0,
    iosMoneyAdjust: 0,
    androidMoneyAdjust: 0
  }
}

// eslint-disable-next-line
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String
  }
})

// eslint-disable-next-line
const emits = defineEmits(['update:visible'])

const dialogVisible = computed({
  get() {
    return props.visible
  },
  set(v) {
    emits('update:visible', v)
  }
})

const addForm = ref(getFormFields())

const rules = {
  gameId: [{ required: true, message: '请选择游戏', trigger: 'change' }]
  // gameAddress: [{ required: true, message: '请输入路径/下载地址', trigger: 'blur' }]
}

const shareRules = [
  { required: true, message: '请输入分成比例', trigger: 'blur' },
  { type: 'number', min: 0, max: 100, message: '分成比例必须在0-100之间', trigger: 'blur' }
]

function onModalClose() {
  addForm.value = getFormFields()
}

function onPlatformChange() {
  addForm.value.gameId = ''
}

// eslint-disable-next-line
defineExpose({
  getFormValue: () => addForm.value,
  setFormValue: (form) => {
    addForm.value = form
  }
})
</script>

<style scoped lang="scss">
.share-inputs {
  margin-top: 16px;
  .el-form-item {
    margin-bottom: 16px;
  }
  .unit {
    margin-left: 8px;
  }
}
</style>
